<template>
  <div class="div-table">
    <div class="columns is-gapless">
      <div class="column is-12 card-header has-text-centered">
        <strong class="is-size-7-touch">Current Point Race Standings</strong>
      </div>
    </div>
    <div class="columns is-gapless is-flex">
      <div class="column is-4 has-text-centered">
        <strong class="is-size-7">List Name</strong>
      </div>
      <div class="column is-4 has-text-centered">
        <strong class="is-size-7">Position</strong>
      </div>
      <div class="column is-4 has-text-centered">
        <strong class="is-size-7">Points</strong>
      </div>
    </div>
    <!--Point races-->
    <div
      v-for="race in races"
      class="columns is-gapless is-flex"
    >
      <div class="column is-4 has-text-centered">
        <router-link
          class="is-size-7"
          :to="{path: `/races/${race[0]}`}"
        >
          {{ race[0] }}
        </router-link>
      </div>

      <div class="column is-4 has-text-centered">
        <span class="is-size-7">{{ race[1].rank }}</span>
      </div>

      <div class="column is-4 has-text-centered">
        <span class="is-size-7">{{ race[1].points }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['races'],
    data () {
      return {}
    },
    methods: {}
  }
</script>